import React, { useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";

const SeriesDetails = ({ viewportData, currentImage, totalImage}) => {
  const {viewportRow, viewportColumn}= useContext(ViewportContext)
  const {hideSeriesAndImageCount} = useContext(studyviewerContext);

  const { t } = useTranslation();
  return (
    <>
      {(isMobile || viewportRow > 2 || viewportColumn > 2) ? (
        <div className="viewport-overlay-series">
          <div>
            <span className="viewport-overlay-key">
              {t("viewer.overlay.image")}:{" "}
            </span>
            <span className="viewport-overlay-value">
              {currentImage + 1}
              {"/"}
              {totalImage + 1}
            </span>
          </div>
        </div>
      ) : (
        <div className="viewport-overlay-series">
          <div>
           {hideSeriesAndImageCount() && <>
            <span className="viewport-overlay-key">
              {t("viewer.overlay.series")}:{" "}
            </span>
            <span className="viewport-overlay-value">
              {viewportData?.series},{" "}
            </span>
            <span className="viewport-overlay-key">
              {t("viewer.overlay.image")}:{" "}
            </span>
            <span className="viewport-overlay-value">
              {currentImage + 1}
              {"/"}
              {totalImage + 1},{" "}
            </span>
            </>}
             <span className="viewport-overlay-key">
              {t("viewer.overlay.modality")}:{" "}
            </span>
            <span className="viewport-overlay-value">
              {viewportData?.modality}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default SeriesDetails;
